import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyIfscCode } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const IFSCVerify = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [ifscCodeData, setIfscCodeData] = useState({});
    const [errors, setErrors] = useState({});
    const [profileData, setProfileData] = useState({});
    const [ifscCode, setIfscCode] = useState("");
    const [showIfscCodeData, setShowIfscCodeData] = useState(false);
    const { serviceName } = useService();


    // Fetch profile data on mount
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);


    const validateForm = (ifscCode) => {
        const errors = {};
        if (!ifscCode.trim()) {
            errors.ifscCode = "IFSC code is required.";
        }
        return errors;
    };



    const handleSubmit = async () => {
        const validationErrors = validateForm(ifscCode);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        try {
            setIsLoading(true);

            const response = await verifyIfscCode({
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                ifscCode: ifscCode,
            });

            const statusCode = response?.status?.code || response?.status;

            if (statusCode === 200) {

                const rcData = response?.data;

                if (rcData) {
                    setIfscCodeData(rcData);
                    showSuccessToast(response.message, "IFSC Code Verified successfully.");
                    setShowIfscCodeData(true)
                    setIfscCode("");
                    setErrors({});
                } else {
                    showErrorToast("Unexpected API format.");
                }
            }


            else if (statusCode === 422) {
                showErrorToast(response.data.message || "Invalid format");
            }

            else if (statusCode === 500) {
                showErrorToast(response.data.message || "Server error");
            }

            else {
                showErrorToast(response.status?.message || "Something went wrong");
            }

        } catch (error) {
            console.error("IFSC code Error:", error);
            showErrorToast("Failed to verify IFSC code.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>



                <InputWithLabel
                    type="text"
                    label="IFSC Code"
                    placeholder="Enter IFSC Code"
                    className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
                    name="ifscCode"
                    id="ifscCode"
                    required={true}
                    value={ifscCode}
                    onChange={(e) => setIfscCode(e.target.value)}
                    error={errors.ifscCode}
                />

                <div>
                    <Button
                        type="button"
                        className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                        id="verifyRC"
                        name="verifyRC"
                        text="Verify"
                        onClick={handleSubmit}
                    />
                </div>
            </div>

            {/* instructions */}
            <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3 mb-6">
                <h2 class="text-xl font-bold text-center text-gray-800 mb-2">IFSC Code Verification Steps</h2>

                <ol class="list-decimal list-inside text-gray-700 space-y-1">
                    <li>Enter your IFSC Code.</li>
                    <li>Click on "Verify" to check bank details.</li>
                </ol>

                <div class="mt-2">
                    <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
                    <ul class="list-disc list-inside text-gray-600 space-y-1">
                        <li>Do not refresh the page during the verification process.</li>
                        <li>Never share Otp, pin related to bank, aadhar, pan to anyone.</li>
                    </ul>
                </div>
            </div>

            {ifscCodeData && showIfscCodeData &&
                (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 px-4">
                        {/* Summary Card */}
                        <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3">
                            <h3 className="text-blue-800 font-semibold text-xl">IFSC code Summary</h3>
                            <div className="text-sm text-gray-700 mt-2">

                                <p><strong>MICR :</strong> {ifscCodeData?.MICR || ""}</p>
                                <p><strong>Branch :</strong> {ifscCodeData?.BRANCH || ""}</p>
                                <p><strong>Address :</strong> {ifscCodeData?.ADDRESS || ""}</p>
                                <p><strong>State :</strong> {ifscCodeData?.STATE || ""}</p>
                                <p><strong>Contact :</strong> {ifscCodeData?.CONTACT || ""}</p>
                                <p><strong>UPI : </strong>{ifscCodeData?.UPI ? 'Yes' : 'No' || ""}</p>
                                <p><strong>RTGS : </strong>{ifscCodeData?.RTGS ? 'Yes' : 'No' || ""}</p>
                                <p><strong>City : </strong>{ifscCodeData?.CITY || ""}</p>
                                <p><strong>Centre : </strong>{ifscCodeData?.CENTRE || ""}</p>
                                <p><strong>District : </strong>{ifscCodeData?.DISTRICT || ""}</p>
                                <p><strong>NEFT : </strong>{ifscCodeData?.NEFT ? 'Yes' : 'No' || ""}</p>
                                <p><strong>SWIFT : </strong>{ifscCodeData?.SWIFT ? 'Yes' : 'No' || ""}</p>
                                <p><strong>ISO3166 : </strong>{ifscCodeData?.ISO3166 || ""}</p>
                                <p><strong>Bank : </strong>{ifscCodeData?.BANK || ""}</p>
                                <p><strong>Bank Code : </strong>{ifscCodeData?.BANKCODE || ""}</p>
                                <p><strong>IFSC : </strong>{ifscCodeData?.IFSC || ""}</p>
                            </div>
                        </div>

                        {/* JSON Preview */}
                        <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2">
                            <h2 className="text-lg font-semibold text-blue-800 mb-1">IFSC code JSON Data</h2>
                            <pre className="bg-gray-100 p-2 rounded text-sm overflow-y-auto max-h-[200px]">
                                {JSON.stringify(ifscCodeData, null, 2)}
                            </pre>
                        </div>
                    </div>
                )}
        </>
    );
};

export default IFSCVerify;
